/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2025-03-06 09:48:38
 * @LastEditors: 
 * @LastEditTime: 2025-03-06 09:55:29
 */
// main.js
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import WaveUI from 'wave-ui'
import 'wave-ui/dist/wave-ui.css'
import "@/assets/styles/responsive.css";
import "@/assets/css/global.css";

import { getWorkspaceId, oneTimeLoginIfNeeded } from "@/api/api.js";
import store from './store';

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 如果需要立即确保 workspaceId
getWorkspaceId();

// 注册 VueRouter
Vue.use(VueRouter);
Vue.use(WaveUI)
const waveui = new WaveUI({
  // Some Wave UI options.
})
// 在应用启动时先尝试一次性登录
oneTimeLoginIfNeeded()
  .then(() => {
    // 一次性登录检查完毕后，再创建和挂载 Vue 实例
    new Vue({
      router,
      store,
      WaveUI,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch((err) => {
    console.error("一次性登录检查出错：", err);
    // 即使一次性登录出错，也继续加载应用，避免白屏
    new Vue({
      router,
      store,
      waveui,
      render: (h) => h(App),
    }).$mount('#app');
  });